import { createTheme } from '@mui/material/styles';
// assets
import colors from '../assets/scss/_themes-vars.module.scss';
// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

export const theme = (customization: any) => {
  const color = colors;

  const themeOption = {
    colors: color,
    // heading: '#f3e500',
    // paper: color.darkBackground,
    // backgroundDefault: color.darkBackground,
    // background: color.darkPaper,
    // darkTextPrimary: color.grey500,
    // darkTextSecondary: color.darkTextPrimary,
    // textDark: color.darkTextTitle,
    // menuSelected: color.darkTextTitle,
    // menuSelectedBack: color.darkLevel1,
    // divider: '#f3e500',
    // divider: color.grey200,
    // customization
  };
  
  const themeOptions: any = {
    direction: 'ltr',
    palette: themePalette(themeOption),
    mixins: {
      toolbar: {
        minHeight: '48px',
        padding: '16px',
        '@media (min-width: 600px)': {
          minHeight: '48px'
        }
      }
    },
    typography: themeTypography(themeOption)
  };

  const themes = createTheme(themeOptions);
  themes.components = componentStyleOverrides(themeOption);

  return themes;
};

export default theme;
